import { useCallback } from "react";
import className from "classnames";
import PropTypes from "prop-types";
import "./MerchandisingFiltersItem.scss";
import IconRight from "app/pages/.shared/static/icons/IconRight";

const MerchandisingFiltersItem = ({ label, onFilterSelect, active }) => {
	const filterClass = className({
		"merchandising-filters-item": true,
		"merchandising-filters-item--active": active,
	});
	const picto = active ? <i className="icon icon--circle-cross-grey" /> : <IconRight />;
	const onSelect = useCallback(() => onFilterSelect(label), [label]);

	return (
		<div className={filterClass} key={label} onClick={onSelect}>
			<i className="icon" />
			<div>{label}</div>
			{picto}
		</div>
	);
};

MerchandisingFiltersItem.propTypes = {
	label: PropTypes.string,
	onFilterSelect: PropTypes.func,
	active: PropTypes.bool,
};

MerchandisingFiltersItem.defaultProps = {
	onFilterSelect: () => {},
	active: false,
};

export default MerchandisingFiltersItem;
